import { useQuery } from "@tanstack/react-query"
import {
  BalanceSituacionCall,
  generateBalanceSituacionExcel,
  getBalanceSituacionByFilters,
} from "api/BalanceSituacion.service"
import Spinner from "common/components/Spinner/"
import { useDownloadFileContext } from "common/context/DownloadFileProvider"
import BalanceTable from "features/Contabilidad/components/BalanceTable"
import SubMenuHeader from "features/Contabilidad/components/SubmenuHeader"
import {
  InformesCommonProps,
  MODES_INFORME,
  PERIOD_OPTIONS,
  formatInformesStorage,
  onTransformArrayData,
  transformMonthArray,
} from "features/Contabilidad/contants"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { backendDateFormat } from "utils/formatDate"
import { DATA_KEYS_BALANCE, TIPO_INFORMES_BALANCE } from "./constants"

const BalanceSituacion = () => {
  const { t } = useTranslation()
  const { handleDirectDownloadExcel } = useDownloadFileContext()

  const [informesFilters, setInformesFilters] = useState<InformesCommonProps>(
    formatInformesStorage()
  )

  useEffect(() => {
    sessionStorage.setItem(
      "informesFilters",
      JSON.stringify({
        ...informesFilters,
        dateFilter:
          informesFilters?.dateFilter === undefined
            ? undefined
            : [
                informesFilters?.dateFilter?.[0],
                informesFilters?.dateFilter?.[1] ?? null,
              ],
        searchValue: informesFilters?.searchValue,
      })
    )
  }, [informesFilters])

  const { data: informe, isLoading: informeLoading } = useQuery({
    queryKey: [
      "getBalance",
      informesFilters?.balance.firstDropdownValue,
      informesFilters?.balance.secondDropdownValue,
      informesFilters?.dateFilter?.[0],
      informesFilters?.dateFilter?.[1],
      informesFilters.searchValue,
      informesFilters?.SoloCuentasConSaldo,
    ],
    queryFn: () => {
      BalanceSituacionCall?.cancel()
      return getBalanceSituacionByFilters({
        EsMensual: informesFilters?.balance.firstDropdownValue,
        Tipo: informesFilters?.balance.secondDropdownValue,
        FechaInicioMovimiento: informesFilters?.dateFilter?.[0]
          ? backendDateFormat(new Date(informesFilters?.dateFilter?.[0]))
          : undefined,
        FechaFinMovimiento: informesFilters?.dateFilter?.[1]
          ? backendDateFormat(new Date(informesFilters?.dateFilter?.[1]))
          : undefined,
        Keyword:
          informesFilters.searchValue !== ""
            ? informesFilters.searchValue
            : undefined,
        SoloCuentasConSaldo: informesFilters?.SoloCuentasConSaldo,
      })
    },
    refetchOnWindowFocus: false,
    retry: false,
  })

  const [isLoadingExcel, setIsLoadingExcel] = useState(false)
  const handleDownLoadExcel = async () => {
    setIsLoadingExcel(true)
    const archivo = await generateBalanceSituacionExcel({
      EsMensual: informesFilters?.balance.firstDropdownValue,
      Tipo: informesFilters?.balance.secondDropdownValue,
      FechaInicioMovimiento: informesFilters?.dateFilter?.[0]
        ? backendDateFormat(new Date(informesFilters?.dateFilter?.[0]))
        : undefined,
      FechaFinMovimiento: informesFilters?.dateFilter?.[1]
        ? backendDateFormat(new Date(informesFilters?.dateFilter?.[1]))
        : undefined,
      Keyword:
        informesFilters.searchValue !== ""
          ? informesFilters.searchValue
          : undefined,
      SoloCuentasConSaldo: informesFilters?.SoloCuentasConSaldo,
    })
    if (archivo) {
      handleDirectDownloadExcel(archivo, "BalanceSituación.xls")
    }
    setIsLoadingExcel(false)
  }

  return (
    <section className='!tw-h-[calc(100%-230px)]'>
      <SubMenuHeader
        title={`${t("informes.selectedTab.headerBalance")}`}
        mode={MODES_INFORME.BALANCE}
        informesFilters={informesFilters}
        setInformesFilters={setInformesFilters}
        handleDownload={() => handleDownLoadExcel()}
        secondOptions={TIPO_INFORMES_BALANCE(t)}
        secondPlaceholder={undefined}
        firstOptions={PERIOD_OPTIONS(t)}
        firstPlaceholder={undefined}
        isLoadingExcel={isLoadingExcel}
      />
      {!informeLoading ? (
        <BalanceTable
          months={transformMonthArray(informe?.tableColumns)}
          period
          onTransformArrayData={onTransformArrayData(informe?.items)}
          dataKeySetup={DATA_KEYS_BALANCE}
        />
      ) : (
        <Spinner />
      )}
    </section>
  )
}

export default BalanceSituacion
